module.exports = "label { font-weight: 700; font-size: 16px; }\n.clear { margin-top: .5em; margin-bottom: .5em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/eventsearch-postedremittance-seidupdate/eventsearch-postedremittance-seidupdate.component.css
// module id = ./src/app/components/event-search/eventsearch-postedremittance-seidupdate/eventsearch-postedremittance-seidupdate.component.css
// module chunks = main